import React from 'react';
import { Alert, Col, Row } from 'reactstrap';
import __ from 'utils/i18n';

export const ErrorResults = ({ errors, fileName, data, errorType, message }) => {
  // Si es error de límite excedido, mostrar UI especial
  if (errorType === 'LIMIT_EXCEEDED') {
    return (
      <div className="import-results-container">
        <Row>
          <Col md='12'>
            <div className="d-flex flex-column align-items-center justify-content-center">
              <i className="mdi mdi-alert-circle text-danger display-3"></i>
              <h3 className="modal-title payment-link-modal__steps__title">
                {__.t("dashboard.sections.massivePaymentLink.import.upload.limitErrorTitle")}
              </h3>
              <p className="lead text-center">
                {__.t("dashboard.sections.massivePaymentLink.import.upload.errorLimitMessage")}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  // UI normal para errores de validación
  return (
    <div className="import-results-container">
      {errors && Array.isArray(errors) && errors.length > 0 ? (
        <Row>
          <Col md='12'>
            {fileName && (
                <div className='import-results-container__file-name'>
                    <span>Archivo:</span>
                    <span>{fileName}</span>
                </div>
            )}
            <hr />
            
            {data?.totalProcessed && (
              <>
                <div className="import-results-container__results">
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Total de registros:</span>
                    <span className="block-content-value text-body">{data.totalProcessed}</span>
                  </div>
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Correctos:</span>
                    <span className="block-content-value text-success">{data.successful}</span>
                  </div>
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Con error:</span>
                    <span className="block-content-value text-danger">{data.failed}</span>
                  </div>
                </div>
              </>
            )}
    
            <hr />
            
            <div className="errors-list block-content">
              <table className="errors-table">
                <thead>
                  <tr>
                    <th style={{width: '76px'}}>Línea</th>
                    <th style={{width: '140px'}}>Campo</th>
                    <th>Error</th>
                    <th style={{width: '30%'}}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {errors.map((error, key) => {
                    const line = error.row || error.line || key + 1;
                    const rawMsg = error.message || error.error || '';
                    const field =
                      error.column ||
                      error.field ||
                      (rawMsg.match(/\(([^)]+)\)/)?.[1] ?? (error.item && (error.item.title ? 'nombre' : error.item.amount !== undefined ? 'monto' : error.item.email ? 'emails' : '')));
                    const value = (() => {
                      if (!error.item) return '';
                      const parts = [];
                      if (error.item.title) parts.push(error.item.title);
                      if (error.item.email) parts.push(error.item.email);
                      if (error.item.amount !== undefined) parts.push(
                        `$ ${Number(error.item.amount).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      );
                      return parts.join(' · ');
                    })();
                    return (
                      <tr key={key}>
                        <td><span className="badge-line">#{line}</span></td>
                        <td>
                          {field
                            ? <span className="badge-field">{field}</span>
                            : <span className="badge-field badge-field--unknown">—</span>}
                        </td>
                        <td className="error-message text-danger">{rawMsg}</td>
                        <td>
                          {value
                            ? <div className="value-mono" title={value}>{value}</div>
                            : <span className="text-muted">sin valor</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <hr />
            <Alert color='warning'>
              <i className='mdi mdi-alert mr-1' />
              {__('dashboard.sections.massivePaymentLink.import.upload.error')}
            </Alert>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md='12'>
            <Alert color='warning'>
              <i className='mdi mdi-alert mr-1' />
              {__('dashboard.sections.massivePaymentLink.import.error')}
            </Alert>
          </Col>
        </Row>
      )}
    </div>
  );
};